@if (customLinks$ | async; as customLinks) {
  <div>
    @if (customLinks.length > 0) {
      <div>
        <button
          mat-icon-button
          [matMenuTriggerFor]="menu"
          aria-label="Custom Links Menu"
        >
          <mat-icon>link</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          @for (link of customLinks; track link) {
            @switch (getLinkItemType(link)) {
              @case (linkType.link) {
                <button mat-menu-item (click)="onClickLink(link)">
                  {{ link.label }}
                </button>
              }
              @case (linkType.header) {
                <div
                  mat-menu-item
                  disableRipple
                  class="custom-link-header"
                  (click)="$event.stopPropagation()"
                >
                  {{ link.label }}
                </div>
              }
              @case (linkType.divider) {
                <mat-divider></mat-divider>
              }
            }
          }
        </mat-menu>
      </div>
    }
  </div>
}

<ng-template #divider>
  <mat-divider></mat-divider>
</ng-template>
